$( document ).ready(function() {
	"use strict";
	//basic
	$('.multi-select').multipleSelect({
		selectAll: false
	});


	$('.multi-select-search').multipleSelect({
		selectAll: true
	});

	//optiongroup
	$('.optmulti-select').multipleSelect({
		multiple: true,
		multipleWidth: 55,
		width: '100%'
	});

	//Multiple Items
	$('.multiselect').multipleSelect({
		width: 460,
		multiple: true,
		multipleWidth: 55
	});

	//hide selectall
	$('.hide-select').multipleSelect({
		selectAll: false
	});

	//Single Row
	$('.single-select').multipleSelect({
		single: true
	});

	$('.single-select-busca').multipleSelect({
	 	single: true, 
	 	filter: true
	});

	//filter-multiple
	$('.filter-multi').multipleSelect({
		filter: true, 
		selectAll: false
	})

	//group-filter
	$('.group-filter').multipleSelect({
		filter: true,
		multiple: true
	});

	//custom
	$('.custom-multiselect').multipleSelect({
		styler: function(value) {
			if (value == '1') {
				return 'background-color: #5e2dd8 ; color: #ffffff;';
			}
			if (value == '6') {
				return 'background-color: #32cafe; color: #ffffff;';
			}
			if (value == '10') {
				return 'background-color: #ff7088; color: #ffffff;';
			}
		}
	});

	//filter-multiple with max 2
	$('.filter-multi_max2').multipleSelect({
		filter: true,
		selectAll: false,
		onClick: function(view) {
			var $select = $(this.$parent.find('select')[0]);
			console.log('select:', $select);
			var selectedValues = $select.multipleSelect('getSelects', 'text');
			console.log('selectedValues:', selectedValues);
			if (selectedValues.length > 2) {
				// Remove o último item selecionado
				selectedValues.pop();
				// Atualiza a seleção
				$select.multipleSelect('setSelects', selectedValues, 'text');
			}
		}
	});

})